import Slider from "@arcgis/core/widgets/Slider";
import { view } from "../../../views/mapView/MapView"

const SliderVM = async(view,container,layer)=>{
const slider = await view.when(()=>{
    const widget = new Slider({
        container: container,
        min: 0,
        max: 1,
        precision: 2,
        values: [layer.opacity],
        visibleElements: {
          labels: true,
          rangeLabels: true,
        },
      });

        widget.on("thumb-drag", (event) => {
          const { value } = event;
          layer.opacity = value;
        });


     return widget
})
return slider
}

export default SliderVM